// extracted by mini-css-extract-plugin
export var inner = "videogroup-module--inner--cd2a6";
export var innerVideo = "videogroup-module--inner-video--7ffc2";